export default __webpack_public_path__ + "static/media/red-thing.ca2a2ea4.png";